import React, { ReactNode, useCallback, useContext, useState } from "react";

type ContextProps = {
  modal: ReactNode | null;
  setModal: (modal: ReactNode) => void;
  clearModal: () => void;
};

const PersistedModalContext = React.createContext<ContextProps>({
  modal: null,
  setModal: () => {},
  clearModal: () => {},
});

export default function PersistedModalProvider({ children }) {
  const [modal, setModal] = useState(null);

  return (
    <PersistedModalContext.Provider
      value={{
        modal,
        setModal,
        clearModal: useCallback(() => setModal(null), [setModal]),
      }}
    >
      {children}
    </PersistedModalContext.Provider>
  );
}

export const usePersistedModal = () => useContext(PersistedModalContext);
